export const M3 = () => (
  <>
    m<span className='align-super text-xs'>3</span>
  </>
);
